(() => {
  const milesBetween = (a, b) => {
    const rad = value => value * Math.PI / 180;
    const dLat = rad(b[0] - a[0]);
    const dLng = rad(b[1] - a[1]);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(dLng / 2) ** 2;
    return 3958.7613 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(Math.max(0, 1 - h)));
  };
  function loadLeaflet(src) {
    if (window.L) return Promise.resolve(window.L);
    if (!window.balanceLeafletReady) {
      window.balanceLeafletReady = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => window.L ? resolve(window.L) : reject(new Error('Map library unavailable'));
        script.onerror = () => reject(new Error('Map library unavailable'));
        document.head.append(script);
      }).catch(error => { window.balanceLeafletReady = null; throw error; });
    }
    return window.balanceLeafletReady;
  }
  function initialise(root) {
    root.querySelectorAll('[data-balance-delivery-area]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const centre = [Number(section.dataset.latitude), Number(section.dataset.longitude)];
      const radius = Number(section.dataset.radius);
      const canvas = section.querySelector('[data-delivery-map]');
      const form = section.querySelector('form');
      const input = form.querySelector('input');
      const button = form.querySelector('button');
      const result = section.querySelector('[data-postcode-result]');
      const reset = section.querySelector('[data-reset-map]');
      let map, area, marker, connector, lastPoint;
      function showPoint(point, postcode, state) {
        if (!map) return;
        if (marker) marker.remove();
        if (connector) connector.remove();
        const label = document.createElement('span');
        label.textContent = postcode;
        const colour = state === 'inside' ? '#237058' : state === 'edge' ? '#916315' : '#52687c';
        marker = window.L.circleMarker(point, {radius: 8, color: '#fff', weight: 3, fillColor: colour, fillOpacity: 1}).addTo(map).bindTooltip(label).openTooltip();
        connector = window.L.polyline([centre, point], {color: colour, weight: 2, dashArray: '5 7'}).addTo(map);
        map.fitBounds(area.getBounds().extend(point), {padding: [24, 24], maxZoom: 12, animate: false});
      }
      loadLeaflet(section.dataset.leafletSrc).then(L => {
        if (!section.isConnected) return;
        canvas.replaceChildren();
        map = L.map(canvas, {scrollWheelZoom: false, tap: false}).setView(centre, 11);
        L.tileLayer(section.dataset.tileUrl, {maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
        area = L.circle(centre, {radius: radius * 1609.344, color: '#23364b', weight: 2, fillColor: '#77bcc7', fillOpacity: .2}).addTo(map);
        L.circleMarker(centre, {radius: 7, color: '#fff', weight: 3, fillColor: '#23364b', fillOpacity: 1}).addTo(map).bindTooltip('BALANCE · Hebden Bridge', {permanent: true, direction: 'top'});
        map.fitBounds(area.getBounds(), {padding: [22, 22], animate: false});
        reset.hidden = false;
        reset.addEventListener('click', () => map.fitBounds(area.getBounds(), {padding: [22, 22], animate: false}));
        if (lastPoint) showPoint(...lastPoint);
        if (window.ResizeObserver) new ResizeObserver(() => { if (section.isConnected) map.invalidateSize(); }).observe(canvas);
        section.addEventListener('balance-map-unload', () => map.remove(), {once: true});
      }).catch(() => {
        canvas.textContent = 'The map is unavailable right now. You can still check your postcode or open Google Maps below.';
        canvas.classList.add('balance-delivery-area__map--unavailable');
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const postcode = input.value.trim().toUpperCase().replace(/\s+/g, '');
        result.hidden = false;
        result.dataset.state = 'neutral';
        if (!/^[A-Z0-9]{5,7}$/.test(postcode)) {
          result.textContent = 'Please enter your full UK postcode, for example HX7 8EH.';
          input.focus();
          return;
        }
        button.disabled = true;
        button.textContent = 'Checking…';
        result.textContent = 'Checking your postcode…';
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(postcode), {signal: controller.signal});
          if (response.status === 404 || response.status === 400) {
            result.textContent = 'We couldn’t find that postcode. Please check it and try again.';
            return;
          }
          if (!response.ok) throw new Error('Lookup unavailable');
          const data = await response.json();
          const location = data.result;
          if (!location || !Number.isFinite(location.latitude) || !Number.isFinite(location.longitude)) throw new Error('Location unavailable');
          const point = [location.latitude, location.longitude];
          const distance = milesBetween(centre, point);
          const state = Math.abs(distance - radius) <= .2 ? 'edge' : distance < radius ? 'inside' : 'outside';
          result.dataset.state = state;
          const heading = document.createElement('strong');
          const detail = document.createElement('span');
          if (state === 'inside') {
            heading.textContent = 'Good news — you’re within our delivery area.';
            detail.textContent = location.postcode + ' is around ' + distance.toFixed(1) + ' miles from BALANCE. Local delivery is ' + section.dataset.fee + ' on Wednesday evenings. Please confirm availability for your full address before ordering.';
          } else if (state === 'edge') {
            heading.textContent = 'You’re close to the edge of our delivery area.';
            detail.textContent = 'Please contact us with your full address so we can confirm local delivery before you order.';
          } else {
            heading.textContent = 'This postcode appears outside our local delivery area.';
            detail.textContent = 'You can still choose postal delivery or collect from BALANCE. If you’re nearby, contact us and we’ll be happy to check your full address.';
          }
          result.replaceChildren(heading, detail);
          lastPoint = [point, location.postcode, state];
          try { showPoint(...lastPoint); } catch (_) { /* Keep the postcode result if the map cannot update. */ }
        } catch (_) {
          result.textContent = 'We couldn’t check your postcode just now. Please try again, or call 01422 760621 and we’ll help.';
        } finally {
          window.clearTimeout(timeout);
          button.disabled = false;
          button.textContent = 'Check postcode';
        }
      });
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-balance-delivery-area]').forEach(section => section.dispatchEvent(new Event('balance-map-unload'))));
})();
